angular.module('aprima-provider-api').factory('ProviderSettingsDtoMapper',
    ['DeviceSettings', 'LocalStorageRepository', function (DeviceSettings, LocalStorageRepository) {
        'use strict';

        function getProviderSettingsDto() {
            var deviceSettings = {
                DashboardSettings: mapDashboardTilesToDto(),
                ScheduleSettings: mapScheduleSettingsToDto(),
                MessageSettings: mapMessageSettingsToDto(),
                GeneralNoteTypes: {
                    PhoneMessageGeneralNoteTypeId: LocalStorageRepository.getPhoneMessageGeneralNoteTypeId(),
                    TaskMessageGeneralNoteTypeId: LocalStorageRepository.getTaskMessageGeneralNoteTypeId(),
                    PortalMessageGeneralNoteTypeId: LocalStorageRepository.getPortalMessageGeneralNoteTypeId(),
                    DefaultVitalsSettingId: LocalStorageRepository.getPatientVitalsDefaultSettingId(),
                    RxRefillMessageGeneralNoteTypeId: LocalStorageRepository.getRxRefillMessageGeneralNoteTypeId(),
                    PharmacyGeneralNoteTypeId: LocalStorageRepository.getPharmacyGeneralNoteTypeId(),
                },
            };

            return {
                PhoneSettings: DeviceSettings.isPhone ? deviceSettings : null,
                TabletSettings: DeviceSettings.isTablet ? deviceSettings : null,
                DesktopSettings: DeviceSettings.isBrowser || DeviceSettings.isPrm ? deviceSettings : null,
            };
        }

        function mapScheduleSettingsToDto() {
            var scheduleSettings = LocalStorageRepository.getAppointmentsListSettings();
            var scheduleBadgeSettings = LocalStorageRepository.getAppointmentsBadgeSettings();

            return {
                ScheduleCalendarIds: _(scheduleSettings.calendarIds).value(),
                HideDischargedAppointments: scheduleBadgeSettings.hideDischarged,
                DisplayEndTime: scheduleSettings.displayEndTime,
                FindSlotForNewAppt: scheduleSettings.findSlotForNewAppt
            };
        }

        function mapMessageSettingsToDto() {
            var messageSettings = LocalStorageRepository.getMessagesListSettings();

            return {
                MessageFilterIds: _(messageSettings.filters).map('Id').value()
            };
        }

        function mapDashboardTilesToDto() {
            var dashboardTiles = LocalStorageRepository.getDashboardTileSettings();

            _.forEach(dashboardTiles.Tiles, function (t) {
                if (t.Calendar) {
                    t.Calendars = [t.Calendar];
                }
            });
            return dashboardTiles;
        }

        return {
            getProviderSettingsDto: getProviderSettingsDto
        };
    }]);
